// this is an autogenerated file from App/ChooseLocation/Support/Locations/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_ChooseLocation_Support_Locations(
  $xid: String!
  $user_id: uuid!
  $organization_filter: vaxiom_sys_organizations_bool_exp
) {
  app_admin_users_access(
    where: {
      organization_level: { _eq: "location" }
      xid: { _eq: $xid }
      user_id: { _eq: $user_id }
      organization: $organization_filter
    }
    order_by: { organization_name: asc }
  ) {
    id
    organization_id
    organization_name
    xid
  }
}

`